import { render, staticRenderFns } from "./CollectedInfo.vue?vue&type=template&id=d0cc2b10&scoped=true"
import script from "./CollectedInfo.vue?vue&type=script&lang=js"
export * from "./CollectedInfo.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/bootstrap4.3.1.min.css?vue&type=style&index=0&id=d0cc2b10&prod&scoped=true&lang=css&external"
import style1 from "./CollectedInfo.vue?vue&type=style&index=1&id=d0cc2b10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cc2b10",
  null
  
)

export default component.exports